'use client';

// Last-resort screen when the root layout itself fails, so it cannot rely on app styles.
export default function GlobalError({ reset }: { error: Error; reset: () => void }) {
  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'grid',
          placeItems: 'center',
          background: '#111',
          color: '#fff',
          fontFamily: 'system-ui, sans-serif',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <p>Something went wrong.</p>
          <button onClick={() => (reset ? reset() : window.location.reload())}>Reload</button>
        </div>
      </body>
    </html>
  );
}
